import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorSelectorComponent } from '../paginator-selector/paginator-selector.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [MatIconModule, CommonModule, PaginatorSelectorComponent, PaginatorSelectorComponent],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss'
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() resultsLength: number = 0;
  @Input() pageSize: number = 0;
  @Input() pageSizeOptions: number[] = [];

  @Output() pageChange = new EventEmitter<{ pageIndex: number; pageSize: number }>();

  items: string[] = [];
  selected: string = '';

  currentPage: number = 1;
  totalPages: number = 1;

  ngOnInit(): void {
    this.items = this.pageSizeOptions.map((option) => option.toString());
    this.selected = this.pageSize.toString();
    this.calculateTotalPages();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resultsLength'] || changes['pageSize']) {
      this.calculateTotalPages();
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
        this.emitPageChange();
      }
    }
  }

  private calculateTotalPages(): void {
    this.totalPages = Math.max(1, Math.ceil(this.resultsLength / this.pageSize));
  }

  onPageSizeSelected(selected: string): void {
    this.selected = selected;
    this.pageSize = Number(selected);
    this.currentPage = 1;
    this.emitPageChange();
  }

  goToFirstPage(): void {
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.emitPageChange();
    }
  }

  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.emitPageChange();
    }
  }

  goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.emitPageChange();
    }
  }

  goToLastPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage = this.totalPages;
      this.emitPageChange();
    }
  }

  public get isFirstPage(): boolean {
    return this.currentPage === 1;
  }

  public get isLastPage(): boolean {
    return this.currentPage === this.totalPages;
  }

  private emitPageChange(): void {
    this.pageChange.emit({ pageIndex: this.currentPage - 1, pageSize: this.pageSize });
  }
}
